<template>
  <div class="master-view">
    <LoebatSidebar />

    <div class="master-view__inner">
      <vue-progress-bar />
      <LoebatToolbar />

      <div class="master-view__content">
        <Transition name="fade-transform" mode="out-in">
          <RouterView />
        </Transition>
      </div>

      <LoebatFooter />
    </div>
  </div>
</template>

<script>
import LoebatToolbar from '@@/layout/Toolbar';
import LoebatSidebar from '@@/layout/Sidebar';
import LoebatFooter from '@@/layout/Footer';

import { SIDENAV_VISIBILITY, CONTRACT, AGENT_PREFERENCES } from '@/store/types';
import { mapActions } from 'vuex';

export default {
  name: 'MasterView',

  components: {
    LoebatToolbar,
    LoebatSidebar,
    LoebatFooter,
  },

  computed: {
    contract() {
      return this.$store.getters[CONTRACT];
    },

    isContractNotPassed() {
      return this.contract === 'NOT-ACCEPTED-PASSED-DUE-DATE';
    },
  },

  mounted() {
    // make the side nav invisible once the route changes
    this.$router.afterEach(this.hideSidebar);

    // fetch agent preferences
    this.fetchAgentPreferences();
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      const { isSudoFromAdmin } = vm.$auth.user;
      if (
        vm.isContractNotPassed &&
        to.name !== 'contract' &&
        !isSudoFromAdmin
      ) {
        vm.$router.replace({ name: 'contract' });
      }
    });
  },

  methods: {
    ...mapActions({
      fetchAgentPreferences: AGENT_PREFERENCES,
    }),
    hideSidebar() {
      // update the offCanvas visibility with a delay
      setTimeout(() => this.$store.dispatch(SIDENAV_VISIBILITY, false), 350);
    },
  },
};
</script>
<style lang="scss">
.master-view {
  position: relative;
  display: flex;
  min-height: 100%;

  &__inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: margin 0.25s;
    overflow-x: hidden;

    padding-top: $lb-navbar-height;

    @include breakpoint(large) {
      margin-left: $lb-off-canvas-width;
      padding-top: 0;

      @include rtl() {
        margin-left: 0;
        margin-right: $lb-off-canvas-width;
      }
    }
  }

  &__content {
    flex: 1;
    overflow-x: hidden;
  }
}

.off-canvas--collapsed ~ .master-view__inner {
  margin-left: $lb-off-canvas-collapsed-width;

  @include rtl() {
    margin-left: 0;
    margin-right: $lb-off-canvas-collapsed-width;
  }
}
</style>
